import { useGuidanceQuery } from './queries/useGuidanceQuery'

/**
 * 指導支援関連のロジックを集約したカスタムフック
 * PostRecordingConfirmationScreenから抽出
 */
export const useGuidanceOperations = (yakurekiId: string | undefined) => {
  // 指導支援データの取得（自動チェック）
  const { data: guidanceData, isLoading: guidanceLoading } = useGuidanceQuery(
    yakurekiId,
    { autoCheck: true }
  )

  return {
    guidanceData,
    guidanceLoading,
    hasGuidanceData: !!guidanceData,
    // 指導支援データが存在し、キーフレーズが設定されている場合
    // GuidanceSupportDataの型定義に基づいて正しいプロパティを参照
    hasKeyPhrases: false, // 一旦falseに設定（実際の型定義に応じて修正が必要）
  }
}
